// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__kWbQw","title":"styles_title__ozsLs","terms":"styles_terms__APXEN","print":"styles_print__oETj5","privacy":"styles_privacy__Ye2W_"};